import ApiClient from './ApiClient';

class UserClient extends ApiClient {
  constructor() {
    super('/users/v1');
  }
}

const userClient = new UserClient();

export default userClient;
